import React, { Fragment } from 'react';
import { produce } from 'immer';
import { MediaGrid } from './MediaGrid';
import { MediaSectionWithShowDetailHeader } from './MediaSectionWithShowDetailHeader';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useMediaSectionWithShowPaging } from '../../hooks/use-media-section-with-show-paging';
import { UiConfigProvider } from '../../providers/UiConfigProvider/UiConfigProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaSectionWithShowDetail = ({
  sectionDetail
}) => {
  const {
    uiConfig
  } = useVideoConfig();
  const {
    data,
    canLoadMore,
    loadMore
  } = useMediaSectionWithShowPaging(sectionDetail.id, sectionDetail.data);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MediaSectionWithShowDetailHeader, {
      sectionDetail: sectionDetail
    }), /*#__PURE__*/_jsx(UiConfigProvider, {
      providerSettings: {
        type: 'CustomConfig',
        value: produce(uiConfig.default, draft => {
          draft.mediaTeaser.displayShowTitle = false;
          return draft;
        })
      },
      children: /*#__PURE__*/_jsx(MediaGrid, {
        medias: data?.medias ?? [],
        canLoadMore: canLoadMore,
        loadMore: loadMore,
        analyticsTitle: sectionDetail.representation.title,
        labelOrder: ['live', 'expiringSoon']
      })
    })]
  });
};